import { useRef } from "react";
import { useTheme } from "../../hooks/useTheme";
import { themeOrder, themes } from "../../themes/themes";
import { cn } from "../../lib/cn";

export function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  const refs = useRef<Array<HTMLButtonElement | null>>([]);

  const onKey = (e: React.KeyboardEvent, idx: number) => {
    if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
    e.preventDefault();
    const dir = e.key === "ArrowRight" ? 1 : -1;
    const next = (idx + dir + themeOrder.length) % themeOrder.length;
    const target = refs.current[next];
    target?.focus();
    setTheme(themeOrder[next]);
  };

  return (
    <div
      className="flex items-center gap-1.5"
      role="radiogroup"
      aria-label="Theme"
    >
      {themeOrder.map((id, idx) => {
        const t = themes[id];
        const selected = theme === id;
        return (
          <button
            key={id}
            ref={(el) => {
              refs.current[idx] = el;
            }}
            role="radio"
            aria-checked={selected}
            aria-pressed={selected}
            aria-label={t.name}
            title={t.name}
            onClick={() => setTheme(id)}
            onKeyDown={(e) => onKey(e, idx)}
            tabIndex={selected ? 0 : -1}
            className={cn(
              "relative h-4 w-4 rounded-full border border-border-default transition-transform duration-fast ease-out",
              "focus-visible:outline-none",
              selected ? "scale-[1.15] shadow-sm" : "hover:scale-110",
            )}
            style={{ background: t.swatch }}
          >
            {selected && (
              <span
                className="absolute inset-0 rounded-full pointer-events-none"
                style={{ boxShadow: "0 0 0 2px var(--border-strong)" }}
                aria-hidden="true"
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
